import { forwardRef, useRef, useState } from "react";
import { FaBuffer, FaCaretDown, FaCaretUp, FaColumns, FaEquals, FaExchangeAlt, FaHistory, FaIdBadge, FaRegIdCard, FaRegUser, FaShieldAlt, FaSortAmountDownAlt, FaSortAmountUpAlt, FaWallet } from "react-icons/fa"
import { Link, useNavigate } from "react-router-dom";
import { ProfileDropdown } from "../modals/ProfileDropdown";
import { MdFace, MdNotificationsActive, MdSettings } from "react-icons/md"
import NotificationDropdown from "../modals/NotificationDropdown"
import SettingsDropdown from "../modals/SettingsDropdown";
import { SiMarketo } from "react-icons/si";
import { CgMenuLeftAlt } from "react-icons/cg";
import { useMainContext } from "../contexts/main";
import { useWindowSize } from "../hooks/common/useWindowSize";
import useClickOutside from "../hooks/common/useClickOutside";
import { useUnreadNotificationQuery } from "../services/react-query/useNotificationsQuery";
import { HOME } from "../constants/urls";
import { MOBILE_SIZE, TABLET_SIZE } from "../constants/common";
import {
    Avatar, Body, DropBody, DropItem,
    Flex, Image, LayoutSettingIcon, LinkRow, Menu, MHeaderButtonWrapper,
    MHeaderIconWrapper,
    MLink,
    MText,
    Notification,
    Profile, RegisterIcon, SinginIcon,
    UnreadNotificationIcon
} from "../styles/HeaderStyles";
import Text from "../utils/Text";
import { AnimatePresence } from "framer-motion";
import { useAuthContext } from "../contexts/auth";


const MasterHeader = ({ onLayoutSetting }) => {

    const lsRef = useRef()
    const { main: { lang, setLang, theme, setTheme }, profile: { token } } = useMainContext()
    const { width } = useWindowSize()
    const navigate = useNavigate()

    const [langOpen, setLangOpen] = useState(false)
    const [profileOpen, setProfileOpen] = useState(false)
    const [settingsOpen, setSettingsOpen] = useState(false)
    const [notificationsOpen, setNotificationsOpen] = useState(false)
    const [menuIsOpen, setMenuIsOpen] = useState(false)

    const langRef = useRef()
    useClickOutside(langRef, () => langOpen && setLangOpen(false))

    const profileRef = useRef()
    useClickOutside(profileRef, () => profileOpen && setProfileOpen(false))

    const notificationRef = useRef()
    useClickOutside(notificationRef, () => notificationsOpen && setNotificationsOpen(false))

    const settingsRef = useRef()
    useClickOutside(settingsRef, () => settingsOpen && setSettingsOpen(false))

    const menuRef = useRef()
    useClickOutside(menuRef, () => menuIsOpen && setMenuIsOpen(false))


    const onThemeChange = () => {
        setTheme(theme === 'dark' ? 'light' : 'dark')
    }

    const { profile, logout } = useAuthContext()
    const { data: notifications, isFetching: notificationsLoading, refetch: refetchUnreadNotifications } = useUnreadNotificationQuery(1)

    const onOptionClicked = (type) => {
        setLangOpen(false)
        switch (type) {
            case "english":
                setLang("en")
                break
            case "فارسی":
                setLang("fa")
                break
            default:
                break
        }
    }

    const onProfileItemsClicked = (type, path = null) => {
        if (type === "exit") {
            logout()
        } else {
            window.location.href = HOME + "user" + path
        }
    }

    const goToSignin = (type) => {
        window.location.href = HOME + `user/register-signin?tab=${type === 'register' ? '0' : '1'}`
    }

    const onLinkClicked = (path) => {
        if (path !== "/markets" && path !== "/otc") {
            window.location.href = HOME + path
        } else {
            navigate(path)
        }
    }


    return (
        <Body resp={width < MOBILE_SIZE}>
            <AnimatePresence exitBeforeEnter>
                {menuIsOpen &&
                    <Menu variants={menuVariants} animate="in" exit="out" initial="out" ref={menuRef}>
                        {mobileLinks(lang).map((link) => {

                            const { icon: Icon } = link
                            let href = HOME
                            if (link.hasLang) href += lang + link.route
                            else href += link.route

                            return (
                                <a
                                    key={link.route}
                                    href={href}
                                >
                                    <LinkRow
                                        key={link.route}
                                        justify='flex-start'
                                    >
                                        <Icon size={22} />
                                        <MLink key={link.text}>
                                            <Text tid={link.text} />
                                        </MLink>
                                    </LinkRow>
                                </a>
                            )
                        })}
                    </Menu>
                }
            </AnimatePresence>
            <Flex>
                {(token) && (width < MOBILE_SIZE) && (
                    <CgMenuLeftAlt
                        onClick={() => setMenuIsOpen((state) => !state)}
                        size={28}
                        color='#c3c5b7'
                    />
                )}
                <img
                    src={require(`../assets/images/logo.png`)}
                    width={80}
                    alt=" "
                    style={{ cursor: 'pointer' }}
                    onClick={() => onLinkClicked('')}
                />
                {width > MOBILE_SIZE &&
                    getLinks(lang).map((link) => (
                        <MLink key={link.title}>
                            {link.external ?
                                <a href={link.path}>
                                    <Text tid={link.title} />
                                </a>
                                :
                                <Link to={link.path}>
                                    <Text tid={link.title} />
                                </Link>
                            }
                        </MLink>
                    ))}
            </Flex>
            <Flex>
                {token ?
                    <Flex
                        style={{ margin: '0 8px', position: "relative", cursor: 'pointer' }}
                        onClick={() => setNotificationsOpen(true)}
                    >
                        <Notification
                            size={20}
                        />
                        {notifications?.data?.length ?
                            <UnreadNotificationIcon />
                            : null
                        }
                    </Flex>
                    : null
                }
                {notificationsOpen &&
                    <NotificationDropdown
                        ref={notificationRef}
                        notifications={notifications}
                        loading={notificationsLoading}
                        onReadANotification={() => refetchUnreadNotifications()}
                    />
                }
                {/*{width > MOBILE_SIZE ?*/}

                {/*    <MHeaderIconWrapper onClick={onThemeChange}>*/}
                {/*        <Flex>*/}
                {/*            {*/}
                {/*                theme === 'dark' ?*/}
                {/*                    <RiSunFill color={'#ffc800'} size={20}/>*/}
                {/*                    :*/}
                {/*                    <BsFillMoonFill color={'#191c20'} size={18}/>*/}
                {/*            }*/}
                {/*        </Flex>*/}
                {/*    </MHeaderIconWrapper>*/}
                {/*    : null*/}
                {/*}*/}
                {width > TABLET_SIZE &&
                    <Flex ref={lsRef}>
                        <LayoutSettingIcon size={20} onClick={() => onLayoutSetting(lsRef)} />
                    </Flex>
                }

                {width > MOBILE_SIZE ?
                    <>
                        <Flex
                            ref={langRef}
                        >
                            <MHeaderIconWrapper
                                onClick={() => setLangOpen(state => !state)}
                            >
                                <Flex>
                                    {langOpen ?
                                        <FaCaretUp color="#c3c5b7" size={18} />
                                        :
                                        <FaCaretDown color="#c3c5b7" size={18} />
                                    }
                                    <MText >
                                        {languages[lang]}
                                    </MText>
                                </Flex>
                            </MHeaderIconWrapper>
                            {langOpen &&
                                <Dropdown
                                    options={languageOptions}
                                    onOptionClicked={onOptionClicked}
                                    active={lang === "en" ? "english" : "فارسی"}
                                />
                            }
                        </Flex>
                    </>
                    :
                    <Flex style={{ margin: "0 5px" }}>
                        <MdSettings onClick={() => setSettingsOpen(true)} size={20} color="#c3c5b7" />
                        {settingsOpen &&
                            <SettingsDropdown ref={settingsRef} />
                        }
                    </Flex>
                }
                {token ?
                    <Profile
                        onClick={() => setProfileOpen(state => !state)}
                        size={width < MOBILE_SIZE ? "34px" : "42px"}
                    >
                        {profile?.avatar ?
                            <Image src={profile?.avatar} alt=" " size={width < MOBILE_SIZE ? "34px" : "42px"} />
                            :
                            <Avatar size={width < MOBILE_SIZE ? 18 : 22} />
                        }
                        {profileOpen &&
                            <ProfileDropdown
                                ref={profileRef}
                                width={width}
                                profile={profile}
                                onProfileItemsClicked={onProfileItemsClicked}
                            />
                        }
                    </Profile>
                    :
                    <>
                        <MHeaderIconWrapper onClick={() => goToSignin("register")}>
                            <Flex>
                                <RegisterIcon size={18} />
                                <MText>
                                    <Text tid="register" />
                                </MText>
                            </Flex>
                        </MHeaderIconWrapper>
                        <MHeaderButtonWrapper onClick={() => goToSignin("signin")}>
                            <Flex>
                                <SinginIcon size={18} />
                                <Text tid="signin" />
                            </Flex>
                        </MHeaderButtonWrapper>
                    </>
                }
            </Flex>
        </Body>
    )
}


const Dropdown = forwardRef((props, ref) => {
    const { options, active, onOptionClicked } = props

    return (
        <DropBody ref={ref}>
            {options.map(option => (
                <DropItem key={option} onClick={() => onOptionClicked(option)} active={active === option}>
                    <Flex style={{ padding: "0 20px" }}>{option}</Flex>
                </DropItem>
            ))}
        </DropBody>
    )
})


const getLinks = (lang) => ([
    // { title: 'main', path: HOME + lang, icon: <FaEquals size={18} />, external: true },
    // { title: 'dashboard', path: HOME + "user/dashboard", icon: <MdSpaceDashboard size={18}/>, external: true },
    { title: 'dashboard', path: HOME + "user/dashboard", icon: <FaExchangeAlt size={18} />, external: true },
    { title: 'otc', path: HOME + lang + "/otc2/form", icon: <FaExchangeAlt size={18} />, external: true },
    { title: 'p2p-trade', path: HOME + "trade/BTC_IRT", icon: <SiMarketo size={18} />, external: true },
    { title: 'markets', path: HOME + lang + "/market", icon: <SiMarketo size={18} />, external: true },
    { title: 'app-download', path: HOME + "/app-download-manual", icon: <SiMarketo size={18} />, external: true },
])

const mobileLinks = (lang) => ([
    { text: 'main', route: '/', icon: FaEquals, hasLang: true },
    { text: 'dashboard', route: 'user/dashboard', icon: FaColumns },
    { text: 'profile', route: 'user/profile', icon: FaRegUser },
    { text: 'security', route: 'user/security', icon: FaShieldAlt },
    { text: 'authentication', route: 'user/authentication', icon: FaIdBadge },
    { text: 'my-wallet', route: 'user/wallets', icon: FaWallet },
    { text: 'transaction-history', route: 'user/transaction-history', icon: FaSortAmountDownAlt },
    { text: 'current-orders', route: 'user/current-orders', icon: FaSortAmountUpAlt },
    { text: 'orders-history', route: 'user/orders-history', icon: FaHistory },
    { text: 'otc-orders', route: 'user/otc-history', icon: FaBuffer },
    { text: 'cards-accounts', route: 'user/accounts-cards', icon: FaRegIdCard },
    { text: 'my-notifications', route: 'user/notifications', icon: MdNotificationsActive },
    { text: 'invite-friends', route: 'user/invite', icon: MdFace },
])


const languages = {
    en: "english",
    fa: "فارسی"
}

const languageOptions = [
    "english", "فارسی"
]

const menuVariants = {
    in: {
        x: 0,
        transition: { duration: 0.4 },
    },
    out: {
        x: 300,
        transition: { duration: 0.4 },
    },
}



export default MasterHeader;



